// import axios from "axios";
// import moment from "moment";

// const axiosInstance = axios.create({
//   baseURL: `${process.env.REACT_APP_API_URI}`,
// });

// axiosInstance.interceptors.request.use( async(config) => {
//   const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
//   const accessTokenExpiration = JSON.parse(storage.getItem("accessTokenExpiration"));
//   const refreshTokenn = JSON.parse(storage.getItem("refreshToken"));

//   const currentDate = moment().format();
//   const isUnderZero = new Date(accessTokenExpiration) - new Date(currentDate);

//   if (isUnderZero <= 1) {
//     try {
//       const { data } = await axios.post(`${process.env.REACT_APP_API_URI}/Auth/CreateWebTokenByRefreshToken`, { refreshToken: refreshTokenn });
//       const { accessToken, accessTokenExpiration, refreshToken, refreshTokenExpires } = data.data;

//       storage.setItem("accessToken", JSON.stringify(accessToken));
//       storage.setItem("accessTokenExpiration", JSON.stringify(accessTokenExpiration));
//       storage.setItem("refreshToken", JSON.stringify(refreshToken));
//       storage.setItem("refreshTokenExpires", JSON.stringify(refreshTokenExpires));
//       config.headers.Authorization = `Bearer ${accessToken}`.replace(/"/g, '');
//       return config
//     } catch (error) {
//       // console.log(error);
//     } 
//   }else if(isUnderZero > 1){
//     const storageAccessToken = storage.getItem('accessToken');
//     if (storageAccessToken) {
//       config.headers.Authorization = `Bearer ${storageAccessToken}`.replace(/"/g, '');
//     }
//     return config;
//   }
// },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// export default axiosInstance;


import axios from "axios";
import { toastApiError } from "../helper/api/toastApiError";
import { expireSession } from "../utils/auth/sessionExpiry";

const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URI}`,
});

let refreshRequest = null;

const readStoredValue = (storage, key) => {
  const value = storage.getItem(key);
  if (value === null) return null;

  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};

const refreshAccessToken = (storage, refreshToken) => {
  if (!refreshRequest) {
    refreshRequest = axios
      .post(`${process.env.REACT_APP_API_URI}/Auth/CreateWebTokenByRefreshToken`, {
        refreshToken,
      })
      .then(({ data }) => {
        const tokenData = data?.data;

        if (
          !tokenData?.accessToken ||
          !tokenData?.accessTokenExpiration ||
          !tokenData?.refreshToken ||
          !tokenData?.refreshTokenExpires
        ) {
          throw new Error("Token yenileme cevabı geçersiz.");
        }

        storage.setItem("accessToken", JSON.stringify(tokenData.accessToken));
        storage.setItem(
          "accessTokenExpiration",
          JSON.stringify(tokenData.accessTokenExpiration)
        );
        storage.setItem("refreshToken", JSON.stringify(tokenData.refreshToken));
        storage.setItem(
          "refreshTokenExpires",
          JSON.stringify(tokenData.refreshTokenExpires)
        );

        return tokenData.accessToken;
      })
      .finally(() => {
        refreshRequest = null;
      });
  }

  return refreshRequest;
};

// Request Interceptor - Access Token'ı ekleme ve yenileme işlemi
axiosInstance.interceptors.request.use(async (config) => {
  const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
  const accessToken = readStoredValue(storage, "accessToken");
  const accessTokenExpiration = readStoredValue(storage, "accessTokenExpiration");
  const refreshToken = readStoredValue(storage, "refreshToken");
  const accessTokenExpiryTime = new Date(accessTokenExpiration).getTime();
  const mustRefreshAccessToken =
    !accessToken ||
    !Number.isFinite(accessTokenExpiryTime) ||
    accessTokenExpiryTime <= Date.now();

  if (mustRefreshAccessToken) {
    if (!refreshToken) {
      const error = new Error("Refresh token bulunamadı.");
      expireSession();
      return Promise.reject(error);
    }

    try {
      const renewedAccessToken = await refreshAccessToken(storage, refreshToken);
      config.headers.Authorization = `Bearer ${renewedAccessToken}`;
      return config;
    } catch (error) {
      expireSession();
      return Promise.reject(error);
    }
  }

  config.headers.Authorization = `Bearer ${accessToken}`;
  return config;
},
  (error) => {
    return Promise.reject(error);
  }
);

// 403 cevapları bir sayfa hatası değil, backend'in iş/yetki mesajıdır.
axiosInstance.interceptors.response.use(
  response => response, 
  error => {
    if (error.response?.status === 401) {
      expireSession();
    } else if (error.response?.status === 403) {
      toastApiError(error, "Bu işlem için yetkiniz bulunmuyor.");
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
